import { Injectable, signal } from '@angular/core';

/**
 * Mantiene el contexto cuando la app corre bajo un dominio personalizado.
 * Se inicializa una vez en el bootstrap (APP_INITIALIZER) y lo consumen las
 * rutas/componentes para conocer el slug del restaurante del dominio.
 */
@Injectable({ providedIn: 'root' })
export class CustomDomainContextService {
  /** True si la app se cargó bajo un dominio personalizado. */
  readonly isCustomDomain = signal<boolean>(false);

  /** Slug del restaurante dueño del dominio (null si no resolvió). */
  readonly slug = signal<string | null>(null);

  /** True si es dominio custom pero NO resolvió a ningún restaurante (→ 404). */
  readonly unresolved = signal<boolean>(false);

  /**
   * Nombre del restaurante dueño del dominio (null si no resolvió). Lo devuelve el
   * mismo endpoint que el slug, así que sale gratis; lo usan las pantallas que
   * necesitan titular la pestaña sin volver a pedir la info (ej. el 404).
   */
  readonly restaurantName = signal<string | null>(null);

  setResolved(slug: string, restaurantName: string | null): void {
    this.isCustomDomain.set(true);
    this.slug.set(slug);
    this.restaurantName.set(restaurantName);
    this.unresolved.set(false);
  }

  setUnresolved(): void {
    this.isCustomDomain.set(true);
    this.slug.set(null);
    this.restaurantName.set(null);
    this.unresolved.set(true);
  }
}
